import { emailFlagsFromApi, emailFlagsToApi } from '../Common/emailFlags';

const createClassModel = (classObj = {}) => {
  return {
    id: classObj.id || null,
    name: classObj.name || '',
    period: classObj.period || '',
    groupId: classObj.group?.id || '',
    unitId: classObj.unit?.id || '',
    schoolId: classObj.school?.id || '',
    department: classObj.department || '',
    hideAnalysisPractice: classObj.hide_analysis_practice || false,
    hideAnalysisSimulation: classObj.hide_analysis_simulation || false,
    hideReports: classObj.hide_reports || false,
    showOnSignup: classObj.show_on_signup || false,
    showRank: classObj.show_rank || false,
    hideCustomTests: classObj.hide_custom_tests || false,
    signUpEmailSaml: classObj.sign_up_email_saml || false,
    showRanking: classObj.show_rank || false,
    hasSimulations: classObj.has_simulations || false,
    contentType: classObj.content_type?.id || '',
    hidePractice: classObj.hide_practice || false,
    hideQrCodeCertificate: classObj.hide_qr_code_certificate || false,
    hideCategoriesScoreCertificate:
      classObj.hide_categories_score_certificate || false,
    scoreControl: classObj.score_control || false,
    scoreAvailable: classObj.score_available ?? true,
    certificateAvailable: classObj.certificate_available ?? true,
    emailSettings: classObj.email_settings ?? true,
    ...emailFlagsFromApi(classObj),
    language: classObj.language || '',
    roundedCefrCertificate: classObj.rounded_cefr_certificate || false,
    roundedOverall: classObj.rounded_overall || false,
    roundedCategories: classObj.rounded_categories || false,
  };
};

const createClassRequestModel = (classObj = {}) => {
  return {
    id: classObj.id,
    name: classObj.name,
    period: classObj.period,
    group_id: classObj.groupId,
    unit_id: classObj.unitId,
    school_id: classObj.schoolId,
    department: classObj.department,
    hide_analysis_practice: classObj.hideAnalysisPractice,
    hide_analysis_simulation: classObj.hideAnalysisSimulation,
    hide_reports: classObj.hideReports,
    hide_custom_tests: classObj.hideCustomTests,
    show_on_signup: classObj.showOnSignup,
    sign_up_email_saml: classObj.signUpEmailSaml,
    show_rank: classObj.showRanking,
    has_simulations: classObj.hasSimulations,
    content_type_id: classObj.contentType,
    hide_practice: classObj.hidePractice,
    hide_qr_code_certificate: classObj.hideQrCodeCertificate,
    hide_categories_score_certificate: classObj.hideCategoriesScoreCertificate,
    score_control: classObj.scoreControl,
    score_available: classObj.scoreAvailable,
    certificate_available: classObj.certificateAvailable,
    email_settings: classObj.emailSettings,
    ...emailFlagsToApi(classObj),
    language: classObj.language,
    rounded_cefr_certificate: classObj.roundedCefrCertificate,
    rounded_overall: classObj.roundedOverall,
    rounded_categories: classObj.roundedCategories,
  };
};

export { createClassModel, createClassRequestModel };
